import { SETTINGS_MODEL_KEY_POINTER } from 'models/daos/settings/constants'

const SETTINGS_DOMAIN = 'settings'
const SETTINGS_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

const SETTINGS_DOMAIN_MAP_KEY = SETTINGS_MODEL_KEY_POINTER

export {
  SETTINGS_DOMAIN,
  SETTINGS_STATE,
  SETTINGS_DOMAIN_MAP_KEY
}
